import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 0 auto;
  padding: 1rem;

  .title {
    font-size: 1.5rem;
    line-height: 1.8125rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  section.warning {
    display: flex;
    flex-direction: row;
    background-color: ${({ theme }) => `rgb(${theme.background.high})`};
    padding: 1.5rem;
    border-radius: 20px;
    margin: 2rem 0rem;
    align-items: center;

    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }

    background-color: #5ee1f5;
    background-image: linear-gradient(45deg, #5ee1f5 0%, #fff 30%);
    box-shadow: 0 0px 0.6em rgb(0 0 0 / 12%);
    transition: box-shadow 0.5s;

    .icon {
      margin-right: 1rem;
    }

    h3 {
      margin: 0 0 0.3rem 0;
    }

    p {
      margin: 0;
      font-size: 0.85rem;
      line-height: 1.3rem;
      font-weight: 500;
      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    }

    a {
      font-weight: 800;
      text-decoration: underline;
      color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }
  }

  @media only screen and (min-width: 800px) {
    padding-left: 6rem !important;
  }
`

export const ButtonWrapper = styled.div`
  width: 10%;
  margin: 1rem 0 1rem auto;
  display: flex;
  justify-content: space-between;

  button {
    background: none;
    border: none;
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }
`
